import { IPillToggleOption } from './pill-toggle-interfaces';
import { KeyboardEvent } from 'react';

interface IPillToggleProps {
    option1: IPillToggleOption;
    option2: IPillToggleOption;
    selectedOption: IPillToggleOption;
    onChange: (option: IPillToggleOption) => void;
    ariaLabel?: string;
}

const PillToggle = ({
    option1,
    option2,
   selectedOption,
    onChange,
    ariaLabel,
}: IPillToggleProps) => {

    const handleKeyDown = (evt: KeyboardEvent<HTMLDivElement>) => {
        switch (evt.key) {
            case 'ArrowLeft':
            case 'ArrowUp': {
                evt.preventDefault();

                if (selectedOption.value !== option1.value) {
                    onChange(option1);
                }
                break;
            }


            case 'ArrowRight':
            case 'ArrowDown': {
                evt.preventDefault();

                if (selectedOption.value !== option2.value) {
                    onChange(option2);
                }
                break;
            }
        }
    };

    return (
        <div
            className="pill-toggle"
            role="radiogroup"
            aria-label={ ariaLabel }
            onKeyDown={ handleKeyDown }>

            <span
                className={`pill-toggle__thumb ${ option2.value === selectedOption.value ? 'pill-toggle__thumb--right' : '' }`}
                aria-hidden="true"
            />

            <button
                type="button"
                role="radio"
                aria-checked={ option1.value === selectedOption.value }
                className="pill-toggle__option"
                tabIndex={ option1.value === selectedOption.value ? 0 : -1 }
                onClick={ () => onChange(option1) }>
                { option1.text }
            </button>

            <button
                type="button"
                role="radio"
                aria-checked={ option2.value === selectedOption.value }
                className="pill-toggle__option"
                tabIndex={ option2.value === selectedOption.value ? 0 : -1 }
                onClick={ () => onChange(option2) }>
                { option2.text }
            </button>
        </div>
    )
};

export default PillToggle;